import React from "react";
import Modal from "../../../shared/ui/Modal";

// Mounted by its parent only while open, so it is always shown.
const SelectAddressModal = ({
  addresses,
  selectedAddressId,
  onSelect,
  onClose,
  title,
}) => (
  <Modal
    isOpen
    onClose={onClose}
    title={title}
    footer={
      <button type="button" className="ui-btn ui-btn--primary" onClick={onClose}>
        Done
      </button>
    }
  >
    {addresses && addresses.length > 0 ? (
      <div className="ui-option-list">
        {addresses.map((address) => (
          <label key={address.id} className="ui-option">
            <input
              type="radio"
              name="addressSelect"
              value={address.id}
              checked={selectedAddressId === address.id}
              onChange={() => onSelect(address.id)}
            />
            <span className="ui-option__text">
              <span className="ui-option__title">
                {address.firstName} {address.lastName}
              </span>
              <span className="ui-option__meta">
                {address.address1}, {address.city}
              </span>
            </span>
          </label>
        ))}
      </div>
    ) : (
      <p className="ui-hint">No addresses available.</p>
    )}
  </Modal>
);

export default SelectAddressModal;
